import { render, staticRenderFns } from "./TacticsOne.vue?vue&type=template&id=1c43a0dc&scoped=true"
var script = {}
import style0 from "./TacticsOne.vue?vue&type=style&index=0&id=1c43a0dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c43a0dc",
  null
  
)

export default component.exports